export const environment = {
  production: true,
  // apiEndpoint: "https://brave-stone-09007a403.2.azurestaticapps.net",
  apiEndpoint: "https://maps.trip4you.net",
  releaseDate: "2025-05-06",
  releaseVersion: "2.6.16_a4b",
  loginWithDevUser: false
};

